module.exports = "<div class=\"container-fluid\">\n  <div class=\"page-header\">\n    <h1>Create New {{adminService.className || 'Object'}}</h1>\n  </div>\n  \n  <div class=\"row\">\n    <div class=\"col-lg-12\">\n      <div class=\"panel\">\n        <div class=\"panel-body\">\n          <app-admin-form *ngIf=\"adminService.schema\" [object]=\"object\" [schema]=\"adminService.schema\" [submitFunction]=\"submitFunction\"></app-admin-form>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/admin/admin-new/admin-new.component.html
// module id = 288
// module chunks = 0 1